document.addEventListener("DOMContentLoaded", () => {

    /* =========================================
       ELEMENTOS
    ========================================= */

    const filtroTipo = document.getElementById("filtro-tipo-select");
    const filtroOrden = document.getElementById("filtro-orden-select");

    const barraPrecio = document.getElementById("barra-precio");
    const precioActual = document.getElementById("precio-actual");

    const contenedorProductos = document.querySelector(".articulo-recultados-tarjetas");

    const productos = Array.from(
        document.querySelectorAll(".tarjeta-producto-resultados")
    );

    const botonCambiarVista = document.getElementById("boton-cambiar-vista");

    if (!contenedorProductos || productos.length === 0) return;

    /* =========================================
       HELPERS
    ========================================= */

    function normalizar(texto) {
        return (texto || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
    }

    function formatearPrecio(numero) {
        return Number(numero).toLocaleString("es-MX");
    }

    /* =========================================
       ACTUALIZAR PRECIO UI
    ========================================= */

    function actualizarPrecioUI() {
        if (!barraPrecio || !precioActual) return;
        precioActual.textContent = `$${formatearPrecio(barraPrecio.value)}`;
    }

    actualizarPrecioUI();

    barraPrecio?.addEventListener("input", () => {
        actualizarPrecioUI();
        aplicarFiltros();
    });

    /* =========================================
       VISTA GRID / LISTA
    ========================================= */

    let vistaCuadricula = true;

    botonCambiarVista?.addEventListener("click", () => {
        vistaCuadricula = !vistaCuadricula;

        if (vistaCuadricula) {
            contenedorProductos.classList.add("vista-cuadricula");
            contenedorProductos.classList.remove("vista-lista");
        } else {
            contenedorProductos.classList.add("vista-lista");
            contenedorProductos.classList.remove("vista-cuadricula");
        }
    });

    /* =========================================
       REGLAS DE FILTRO
    ========================================= */

    const reglasFiltro = {

        "sillon": {
            match: ["sillon"] // coincide con "sillón" tras normalizar
        },

        "reclinable": {
            match: ["reclinable"]
        },

        "sofa-cama": {
            match: ["sofa cama"] // coincide con "sofá cama" tras normalizar
        },
        "sofa-y-love-seat": {
            match: ["sofá y love seat", "sofa y love seat"]
        },
        "salas-modulares": {
            match: ["modular"]
        },
        "salas-de-piel": {
            match: ["piel"]
        },
        "taburete": {
            match: ["taburete"]
        }
    };

    /* =========================================
       FILTRO PRINCIPAL
    ========================================= */

    function aplicarFiltros() {

        const tipo = filtroTipo?.value || "todos";
        const precioMax = Number(barraPrecio?.value || 999999);
        const orden = filtroOrden?.value || "";

        let visibles = [];

        productos.forEach((producto) => {

            const titulo = normalizar(producto.dataset.titulo);
            const precio = Number(producto.dataset.precio) || 0;

            /* =========================
               FILTRO TIPO
            ========================= */

            let coincideTipo = true;

            if (tipo !== "todos") {

                const regla = reglasFiltro[tipo];

                if (regla?.match) {
                    coincideTipo = regla.match.some(palabra =>
                        titulo.includes(palabra)
                    );
                } else {
                    coincideTipo = false;
                }
            }

            /* =========================
               FILTRO PRECIO
            ========================= */

            const coincidePrecio = precio <= precioMax;

            /* =========================
               MOSTRAR / OCULTAR
            ========================= */

            if (coincideTipo && coincidePrecio) {
                producto.style.display = "flex";
                visibles.push(producto);
            } else {
                producto.style.display = "none";
            }

        });

        /* =========================
           ORDENAMIENTO
        ========================= */

        if (orden === "menor-mayor") {
            visibles.sort((a, b) =>
                Number(a.dataset.precio) - Number(b.dataset.precio)
            );
        }

        if (orden === "mayor-menor") {
            visibles.sort((a, b) =>
                Number(b.dataset.precio) - Number(a.dataset.precio)
            );
        }

        /* =========================
           REORDEN DOM
        ========================= */

        visibles.forEach(el => contenedorProductos.appendChild(el));
    }

    /* =========================================
       EVENTOS
    ========================================= */

    filtroTipo?.addEventListener("change", aplicarFiltros);
    filtroOrden?.addEventListener("change", aplicarFiltros);

    /* =========================================
       INICIO
    ========================================= */

    aplicarFiltros();

});